import { useMemo } from 'react';
import { useIsMounted } from './useIsMounted';
// A temporary solution to solve React Hydration Error on Next.js
// details: https://nextjs.org/docs/messages/react-hydration-error
export function useDynamicObject(value, defaultValue) {
    const isMounted = useIsMounted();
    return useMemo(() => isMounted ? value : Object.assign(Object.assign({}, value), defaultValue), [defaultValue, isMounted, value]);
}
